import { MutationTree } from "vuex";
import { ThemeState, FontFamily, IllustrationEntry } from "../types";

function hexToRgb(hex) {
  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return r + "," + g + "," + b;
}

const mutations: MutationTree<ThemeState> = {
  setAccentColor(state, accentColor) {
    // Set primary accent color for tailwind styles
    const root = document.body;
    const accentColorAsRGB = hexToRgb(accentColor.substring(1));
    root.style.setProperty("--primary", accentColorAsRGB);
    state.accentColor = accentColor;
  },
  setSecondaryColor(state, secondaryColor) {
    state.secondaryColor = secondaryColor;
  },
  setGradientStart(state, start: string) {
    state.gradient.start = start;
  },
  setGradientStop(state, stop: string) {
    state.gradient.stop = stop;
  },
  setFontFamily(state, fontFamily: FontFamily) {
    state.fontFamily = fontFamily;
  },
  setWelcomeIllustration(state, illustration: IllustrationEntry) {
    state.illustrations.welcome = illustration;
  },
  setPrepareSelfieIllustration(state, illustration: IllustrationEntry) {
    state.illustrations.prepareSelfie = illustration;
  },
  setChooseCountryIllustration(state, illustration: IllustrationEntry) {
    state.illustrations.chooseCountry = illustration;
  },
  setDriversLicenseFrontIllustration(state, illustration: IllustrationEntry) {
    state.illustrations.driversLicenseFront = illustration;
  },
  setDriversLicenseBackIllustration(state, illustration: IllustrationEntry) {
    state.illustrations.driversLicenseBack = illustration;
  },
  setNationalIdFrontIllustration(state, illustration: IllustrationEntry) {
    state.illustrations.nationalIdFront = illustration;
  },
  setNationalIdBackIllustration(state, illustration: IllustrationEntry) {
    state.illustrations.nationalIdBack = illustration;
  },
  setPassportIllustration(state, illustration: IllustrationEntry) {
    state.illustrations.passport = illustration;
  },
};

export default mutations;
